import { EuiSpacer } from '@elastic/eui';
import NavButtons from 'components/1080p_Series_CGI_List/NavButtons';
import * as React from 'react';
export default {
  EuiSpacer,
  NavButtons,
  React
};